import { OnInit } from '@angular/core';
import { TableDataSource } from './table-datasource';
var TableComponent = /** @class */ (function () {
    function TableComponent() {
        /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
        this.displayedColumns = ['scoreRange', 'grade'];
    }
    TableComponent.prototype.ngOnInit = function () {
        this.dataSource = new TableDataSource();
    };
    return TableComponent;
}());
export { TableComponent };
